import { ApiKeyResponseDto } from '../../model/dto/api-key';
import { OrderBy } from '../../types';

const getSortValue = (
  apiKey: ApiKeyResponseDto,
  orderBy: string
): string | number => {
  switch (orderBy) {
    case 'partner_name':
      return apiKey.partner_name?.toLowerCase() ?? '';
    case 'partner_route':
      return apiKey.partner_route?.toLowerCase() ?? '';
    case 'status':
      return apiKey.status ?? '';
    case 'usage_count':
      return apiKey.usage_count ?? 0;
    case 'created_at':
      return new Date(apiKey.created_at ?? '').getTime();
    default:
      return 0;
  }
};

const includesText = (value: string | undefined, search: string) =>
  (value ?? '').toLowerCase().includes(search.trim().toLowerCase());

export const filterApiKeys = (
  apiKeys: ApiKeyResponseDto[],
  filters: Record<string, string>
): ApiKeyResponseDto[] =>
  apiKeys.filter(
    (apiKey) =>
      includesText(apiKey.partner_name, filters.partner_name ?? '') &&
      includesText(apiKey.partner_route, filters.partner_route ?? '') &&
      (!filters.status || apiKey.status === filters.status)
  );

export const sortApiKeys = (
  apiKeys: ApiKeyResponseDto[],
  sorting?: OrderBy
): ApiKeyResponseDto[] => {
  if (!sorting) {
    return apiKeys;
  }

  const direction = sorting.order_dir === 'desc' ? -1 : 1;

  return [...apiKeys].sort((first, second) => {
    const firstValue = getSortValue(first, sorting.order_by);
    const secondValue = getSortValue(second, sorting.order_by);

    if (firstValue < secondValue) {
      return -direction;
    }

    return firstValue > secondValue ? direction : 0;
  });
};
